import dayjs from "dayjs";
import duration from "dayjs/plugin/duration";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";

export const ONE_SECOND = 1000;
export const ONE_MINUTE = 60 * ONE_SECOND;
export const ONE_HOUR = 60 * ONE_MINUTE;
export const ONE_DAY = 24 * ONE_HOUR;
export const ONE_WEEK = 7 * ONE_DAY;
export const ONE_MONTH = 30 * ONE_DAY;
export const ONE_YEAR = 365 * ONE_DAY;

dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(duration);

export const parseIsoDurationToMs = (iso: string): number =>
  dayjs.duration(iso).asMilliseconds();

export const convertDatesToLocal = (dates: Date[]) => {
  return dates.map((date) => {
    return convertDateToLocal(date);
  });
};

export const convertDateToLocal = (date: Date) => {
  const localDayjs = dayjs(date).tz(dayjs.tz.guess());
  return localDayjs.toDate();
};
